// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"AttachmentWrapper__Wrapper_3lx4d"};